import { PowerBiFrame } from "../../../components/frame";

export function BankingAnalytics () {
    return (
      PowerBiFrame
      ({
        title:"Trader Banking",
        url:"https://app.powerbi.com/view?r=eyJrIjoiNDRmODdlYjUtMWEyZS00NWRmLTkwNGItM2YyZmVjOWEyZjc0IiwidCI6IjdhN2NhNjdjLWFlMGEtNGZkMy04ZGRkLThjNDgwZTBmYjM1ZSJ9&pageName=ReportSection24cfa4d319b4ba7d2f3f"
      }));
  }